import React from "react"
import { Link, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { MARKS, BLOCKS } from '@contentful/rich-text-types';

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm, scale } from "../utils/typography"
import Prism from 'prismjs';
import "prismjs/components/prism-typescript";
import "prism-themes/themes/prism-synthwave84.css"
import styles from "./blog-post.module.css"

const defaultLanguage = 'javascript';
const languageRegex = new RegExp(/(<!)\w+(!>)/g);

const parseForLanguage = (text) => {
  const foundStrings = languageRegex.exec(text);
  if (foundStrings && foundStrings.length) {
    return foundStrings[0].replace('<!', '').replace('!>', '');
  } else {
    return defaultLanguage
  }
}

const options = {
  renderMark: {
    [MARKS.CODE]: text => {
      const language = parseForLanguage(text);
      const html = Prism.highlight(text, Prism.languages[language], language);
      return (<code className={'language-'+language} dangerouslySetInnerHTML={{__html: html}}></code>);
    },
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const marks = node.content[0].marks;
      const code = (marks && marks[0]) ? marks[0].type : false;
      if (code === MARKS.CODE) {
        return (<pre className={"line-numbers language-javascript "+ styles.codeBlock} >{children}</pre>);
      }
      return (<p>{children}</p>)
    }
  }
};

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.contentfulPost
    const siteTitle = this.props.data.site.siteMetadata.title
    const { previous, next } = this.props.pageContext

    const content = documentToReactComponents(post.content.json, options);

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.title}
          // description={post.description || post.excerpt}
        />
        <article>
          <header>
            <h1
              style={{
                marginTop: rhythm(1),
                marginBottom: 0,
              }}
            >
              {post.title}
            </h1>
            <p
              style={{
                ...scale(-1 / 5),
                display: `block`,
                marginBottom: rhythm(1),
              }}
            >
              {post.createdAt}
            </p>
          </header>
          <section>
            { content }
          </section>
          <hr
            style={{
              marginBottom: rhythm(1),
            }}
          />
          <footer>
            <Bio />
          </footer>
        </article>

        <nav>
          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.slug} rel="prev">
                  ← {previous.title}
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.slug} rel="next">
                  {next.title} →
                </Link>
              )}
            </li>
          </ul>
        </nav>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query ContentfulPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    contentfulPost(slug: {eq: $slug}) {
      createdAt(formatString: "ddd DD MMM YYYY")
      slug
      title
      updatedAt(formatString: "ddd DD MMM YYYY")
      content {
        json
      }
    }
  }
`
